'use strict';

var $Object = require('es-object-atoms');
/** @type {import('./Object.getPrototypeOf')} */


module.exports = $Object.getPrototypeOf || null;